import React from 'react';
import {Cards,Chart,CountryPicker} from "./Components";
import styles from "./App.module.css";
import {fetchData} from "./API";

import coronaImage from "./images/image.png";


class App extends React.Component{
    state = {
        data :{},
        country:"",
    }
    async componentDidMount(){
        const fetcheddata = await fetchData();
        
        this.setState({data : fetcheddata});
    }

     handleCountryChange =async (country) =>{
        
        const fetchedData = await fetchData(country);
        
        this.setState({data : fetchedData , country : country});

    }

    render() {
        const {data,country} = this.state;
        return (
            <div className= {styles.container}>
                <img className = {styles.image} src = {coronaImage} alt = "COVID-19"></img>
                <Cards data={data} />
                <CountryPicker handleCountryChange= {this.handleCountryChange}/>
                <Chart data = {data} country= {country}/>
            </div>
        );
    }
}

export default App;